import { FC } from 'react';
import { IonButton } from '@ionic/react';
import { createUseStyles } from 'react-jss';
import { Text } from './Text';

const useStyles = createUseStyles({
    container: {
        display: 'flex',
        flexDirection: 'column' as const,
        alignItems: 'flex-start',
        gap: 10,
        padding: '16px 2px',
    },
});

export interface IInlineLoadErrorProps {
    message: string;
    onRetry: () => void;
    dataId?: string;
}

// Inline "couldn't load, try again" affordance for a list/detail surface whose fetch failed, so the
// user can recover in place instead of the surface silently falling through to an empty state (or a
// global alert with no way to retry).
export const InlineLoadError: FC<IInlineLoadErrorProps> = ({ message, onRetry, dataId }) => {
    const classes = useStyles();

    return (
        <div className={classes.container} data-type="inline-load-error" data-id={dataId}>
            <Text type="detail">{message}</Text>
            <IonButton fill="outline" size="small" color="primary" onClick={onRetry} data-id={dataId ? `${dataId}-retry` : undefined}>
                Try again
            </IonButton>
        </div>
    );
};
